import { BasicoApi } from '@common/api';
const TagsContratoClausulaContratualService = {
  listar: function (parametros) {
    return BasicoApi.get()('/tagsContratoClausulaContratual', parametros);
  },
};

export default TagsContratoClausulaContratualService;
